import initHeader from './header';
import initFooter from './footer';

export default function initLayout($) {
  initHeader($);
  initFooter($);
}
